import { useTranslation } from "react-i18next";

const sections = [
  { title: "whatMovesUs_s1Title", body: "whatMovesUs_s1Body" },
  { title: "whatMovesUs_s2Title", body: "whatMovesUs_s2Body" },
  { title: "whatMovesUs_s3Title", body: "whatMovesUs_s3Body" },
  { title: "whatMovesUs_s4Title", body: "whatMovesUs_s4Body" },
  { title: "whatMovesUs_s5Title", body: "whatMovesUs_s5Body" },
];

const WhatMovesUs = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-home">
      <header className="bg-darkBlue text-white">
        <div className="max-w-4xl mx-auto px-4 pt-28 pb-12 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
            {t("whatMovesUs_pageTitle")}
          </h1>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-4 py-10 sm:px-6 lg:px-8 space-y-8">
        <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sm:p-8 space-y-4">
          <p className="text-xl font-semibold text-gray-900 leading-relaxed">
            {t("whatMovesUs_intro")}
          </p>
          <p className="text-gray-700 leading-relaxed">
            {t("whatMovesUs_body")}
          </p>
        </section>

        {sections.map((section) => (
          <section
            key={section.title}
            className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
          >
            <div className="px-6 py-4 bg-lightBlue border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">
                {t(section.title)}
              </h2>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-700 leading-relaxed">{t(section.body)}</p>
            </div>
          </section>
        ))}

        <section className="bg-lightBlue rounded-lg border border-indigo-200 p-8 text-center">
          <p className="text-xl font-semibold text-darkBlue">
            {t("whatMovesUs_quote")}
          </p>
        </section>
      </div>
    </div>
  );
};

export default WhatMovesUs;
